<template>

    <div>
      <input type="file" multiple accept="image/jpeg" @change="detectFiles($event.target.files)">
      <div class="progress-bar" :style="{ width: progressUpload + '%'}">{{ progressUpload }}%</div>
    </div>
  
  </template>
  
  <script>
  import FirebaseCrud from ".././Firebase/services/FirebaseStorage";
  export default {
    data () {
      return {
        progressUpload: 0,
        file: File,
        uploadTask: '',
      }
    },
    methods: {
      detectFiles (fileList) {
        Array.from(Array(fileList.length).keys()).map( x => {
          this.upload(fileList[x])
        })
      },
      upload (file) {
        this.uploadTask = FirebaseCrud.upload("images",file);
      }
    },
    watch: {
     
    }
  }
  </script>
  
  <style>
  .progress-bar {
    margin: 10px 0;
  }
  </style>